import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import styled from "@emotion/styled";
import * as React from "react";
import Box from "@mui/material/Box";
import TableHead from "@mui/material/TableHead";
import TableSortLabel from "@mui/material/TableSortLabel";
import Checkbox from "@mui/material/Checkbox";
import { visuallyHidden } from "@mui/utils";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import "./TableView.css";
import { alpha } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { useTranslation } from "react-i18next";
import { getSingleVehiclePartsDetails } from "../../../services/SurveyRequest";
import { PART_TABLE_SURVEY } from "../../../utils/GlobalFormConstants";
import TextInput from "../textInput/TextInput";
import {
  COMP_PART_WIDTH,
  COPY,
  DELETE_LABEL,
  ENGINE_MAKEMODEL_WIDTH,
  HEIGHT10,
  PARTS,
  PART_NUMBER_WIDTH,
  PART_TABLE_WIDTH,
  SELECTED_LABEL,
  SELECTED_STYLE,
  SELECTED_STYLE_RIGHT,
  TABLE_CELL_STYLE,
  VEHICLE,
  VEHICLE_LIST,
  VEHICLE_TO_COPY,
  WHITE,
} from "../../../utils/GlobalConstants";
import InfoPopover from "../InfoTooltip/InfoTooltip";

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgb(229, 231, 243)",
    paddingLeft: 10,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    paddingLeft: 10,
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export const descendingComparator = function descendingComparator(
  a,
  b,
  orderBy
) {
  if (a.values[orderBy] && b.values[orderBy]) {
    if (
      typeof a.values[orderBy].displayValue == "string" &&
      typeof b.values[orderBy].displayValue == "string"
    ) {
      if (
        b.values[orderBy].displayValue.toLowerCase() <
        a.values[orderBy].displayValue.toLowerCase()
      ) {
        return -1;
      }
      if (
        b.values[orderBy].displayValue.toLowerCase() >
        a.values[orderBy].displayValue.toLowerCase()
      ) {
        return 1;
      }
    } else {
      if (b.values[orderBy].displayValue < a.values[orderBy].displayValue) {
        return -1;
      }
      if (b.values[orderBy].displayValue > a.values[orderBy].displayValue) {
        return 1;
      }
    }
  }
  return 0;
};

export const getComparator = function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};

export const stableSort = function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
};

export const EnhancedTableHead = function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    headCells,
    setUnitSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  const { t } = useTranslation();
  return (
    <TableHead className="tableHead"  data-testid="table-head">
      <TableRow>
        {props.source === VEHICLE_TO_COPY && (
          <StyledTableCell padding="checkbox" className="tableCellHead">
            <div className="tableHeadCheckBoxPosition">
              {props.source === VEHICLE_TO_COPY && (
                <FormControlLabel value="female" control={<Radio />} label="" />
              )}
              {props.source === VEHICLE_TO_COPY && ""}
            </div>
          </StyledTableCell>
        )}
        {headCells.map((headCell) =>
          headCell.id === "sortBy" || headCell.id === "unitNo" ? (
            <StyledTableCell
              className="tableHeadCellSortUnit"
              key={headCell.id}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id, setUnitSort)}
              >
                {props.source !== VEHICLE_TO_COPY && (
                  <SaveOutlinedIcon className="tableHeadCellSortUnitImg" />
                )}

                {t(`tab1.contents.${headCell.label}`)}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </StyledTableCell>
          ) : (
            <StyledTableCell
              key={headCell.id}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={
                props.source !== VEHICLE_TO_COPY
                  ? headCell.id === "engine" || headCell.id === "makeModel"
                    ? ENGINE_MAKEMODEL_WIDTH
                    : 
                    headCell.id === "partType" ||
                      headCell.id === "quantity" ||
                      headCell.id === "brand"
                    ? PART_TABLE_WIDTH
                    : headCell.id === "partNumber"
                    ? PART_NUMBER_WIDTH
                    : COMP_PART_WIDTH
                  : ""
              }
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {t(`tab1.contents.${headCell.label}`)}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </StyledTableCell>
          )
        )}
        {(props.source === VEHICLE || props.source === PARTS) && (
          <><StyledTableCell padding="checkbox" className="tableHeadCheckbox">
            <div className="tableHeadCheckBoxPosition">
              <Checkbox
                color="primary"
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={rowCount > 0 && numSelected === rowCount}
                onChange={onSelectAllClick}
                inputProps={{
                  "aria-label": "select all desserts",
                }}
              />
              {props.source === "Vehicle" && t("tab1.contents.Select_All")}
              {props.source === "Parts" && t("tab1.contents.Select_All")}
            </div>
          </StyledTableCell><StyledTableCell padding="checkbox" className="tableHeadCheckbox">
            <div className="tableHeadCheckBoxPosition">
              
              {props.source === "Vehicle" && 'VIN Status'}
             
            </div>
          </StyledTableCell></>
        )}
      </TableRow>
    </TableHead>
  );
};

export const EnhancedTableToolbar = function EnhancedTableToolbar(props) {
  const { numSelected, source, setOpen, setdel } = props;
  const { t } = useTranslation();
  return (
    <Toolbar
    data-testid={props?.dataTestid}
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        }),
      }}
    >
      {source !== VEHICLE_TO_COPY && numSelected > 0 ? (
        <Typography
          sx={{ ...SELECTED_STYLE, ...SELECTED_STYLE_RIGHT }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} {SELECTED_LABEL}
        </Typography>
      ) : (
        <Typography
          sx={SELECTED_STYLE}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          {source === VEHICLE_TO_COPY
            ? VEHICLE_LIST
            : source === "Parts"
            ? t("tab1.contents.Available_Parts")
            : t("tab1.contents.Available_Vehicle")}
        </Typography>
      )}

      {numSelected > 0 && (
        <>
          {source === PARTS && (
            <Tooltip title={COPY}>
              <IconButton>
                <FileCopyIcon testid="copy" onClick={() => setOpen(true)} />
              </IconButton>
            </Tooltip>
          )}
          {source !== VEHICLE_TO_COPY && (
            <Tooltip title={DELETE_LABEL}>
              <IconButton>
                <DeleteIcon testid="delete" onClick={() => setdel(true)} />
              </IconButton>
            </Tooltip>
          )}
        </>
      )}
    </Toolbar>
  );
};

export const EnhancedCell = (props) => {
  if (props.type === "text") return textField(props);
  else if (props.type === "input") return inputField(props);
  else if (props.type === "check") return checkBox(props);
  else if (props.type === "radio") return radioField(props);
   else if (props.type === "status") return statusInfo(props);
  else return <div>{"default"}</div>;
};
const textField = (props) => {
  return (
    <StyledTableCell
      align="left"
      sx={{
        ...TABLE_CELL_STYLE,
        color: props.selectedID === props.row.id && WHITE,
      }}
    >
      <span>{props.value.displayValue}</span>
    </StyledTableCell>
  );
};
const inputField = (props) => {
  return (
    <StyledTableCell
      align="left"
      sx={{
        ...TABLE_CELL_STYLE,
        color: props.selectedID === props.row.id && WHITE,
      }}
    >
      <TextInput
        label={""}
        testid="input"
        className="bgWhite"
        value={props.value.displayValue}
        onChange={(e) => {
          props.handleChange(e, props.row, props.value.id);
        }}
        onBlur={(e) => {
          props.handleBlur(e, props.row);
        }}
        inputProps={{
          style: HEIGHT10,
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      />
    </StyledTableCell>
  );
};
const checkBox = (props) => {
  return (
    <StyledTableCell padding="checkbox" align={"center"}>
      <Checkbox
        testid="check"
        onClick={(event) =>
          props.handleClickCheckbox(event, props.row.id, props.row)
        }
        sx={{
          color: props.selectedID === props.row.id && WHITE,
        }}
        checked={props.isItemSelected}
        inputProps={{
          "aria-labelledby": props.labelId,
        }}
      />
    </StyledTableCell>
  );
};

const statusInfo = (props) => {
  return (
    <StyledTableCell padding="checkbox" align={"center"}>
      {/* <Checkbox
        testid="check"
        onClick={(event) =>
          props.handleClickCheckbox(event, props.row.id, props.row)
        }
        sx={{
          color: props.selectedID === props.row.id && WHITE,
        }}
        checked={props.isItemSelected}
        inputProps={{
          "aria-labelledby": props.labelId,
        }}
      /> */}
      {props.row?.values?.status?.displayValue && <InfoPopover sx={ {color: 'red'} }/>}
    </StyledTableCell>
  );
};
const radioField = (props) => {
  return (
    <StyledTableCell padding="checkbox" align={"center"}>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        name="radio-buttons-group"
      >
        <FormControlLabel
          value={props.row.id}
          control={
            <Radio
              checked={props.rad === props.row.id}
              testid="radio"
              onChange={(e) => {
                props.setrad(e.target.value);
                props.handleRadio(e.target.value);
              }}
              sx={{
                color: props.selectedID === props.row.id && WHITE,
              }}
            />
          }
          label=""
        />
      </RadioGroup>
    </StyledTableCell>
  );
};
export const getAllParts = async (source, selectedVehicle, setrows) => {
  if (source === PARTS && selectedVehicle?.id) {
    try {
      const response = await getSingleVehiclePartsDetails(selectedVehicle?.id);
      const tmparr = [...response?.partDetailsList];
      const transformedData = transformToTable(PART_TABLE_SURVEY, tmparr);
      setrows(transformedData);
    } catch (e) {}
  } else {
    if (source === PARTS && !selectedVehicle?.id) {
      setrows([]);
    }
  }
};
const vinValidation=(vin)=>{
  if(vin){
    if(!vin?.vinFlag){
      return true
    }else{  return false}
  }else{return false}
}
export const transformToTable = (header, input) => {
  const transformedData = [];
  input.forEach((obj) => {
    const result = {};
    header.forEach((key) => {
      if (
        key.valueFor === "makeModel" &&
        (!obj[key.valueFor] || obj[key.valueFor] === "")
      ) {
        result[key.valueFor] = {
          displayValue:
            obj.make && obj.model
              ? obj.make + "/" + obj.model
              : obj.make
              ? obj.make
              : obj.model
              ? obj.model
              : "",
          type: key.type,
        };
      } 
       if (
        key.valueFor === "status" &&
        (!obj[key.valueFor] || obj[key.valueFor] === "")
      ) {
        result[key.valueFor] = {
          displayValue:vinValidation(obj),
            
          type: key.type,
          
          id: key.id,
        };
      }
      else {
        result[key.valueFor] = {
          displayValue:
            !obj[key.valueFor] || obj[key.valueFor] === ""
              ? key.altValueFor && obj[key.altValueFor]
                ? obj[key.altValueFor]
                : key.defaultValue
              : obj[key.valueFor],
          type: key.type,
          id: key.id,
        };
      }
    });
    transformedData.push({
      id: obj.id,
      values: result,
      source: obj,
    });
  });
  return transformedData;
};
